import {
  css,
  CSSObject,
  forBrands,
  styled,
  Theme,
} from '@core-ui/react-stitch';

interface DashBoardStyleProps extends DashBoardProps {
  theme: Theme;
  newDashboard?: boolean;
}
interface DashBoardProps {
  newDashboard?: boolean;
}
const getBRStyles = (): CSSObject =>
  ({
    paddingTop: '0',
    margin: '0 auto',
    alignItems: 'start',
  } as CSSObject);

const getDefaultStyles = (newDashboard: boolean | undefined): CSSObject =>
  ({
    paddingTop: '0.1rem',
    margin: newDashboard ? '1rem auto' : '0.5rem auto',
  } as CSSObject);
// eslint-disable-next-line complexity
const getDashboardStyles = ({ theme, newDashboard }: DashBoardStyleProps) => {
  const borderWidth = 1;
  const borderStyle = newDashboard
    ? `${borderWidth}px solid ${theme.color.b1}`
    : 'none';
  return css({
    alignItems: 'baseline',
    border: borderStyle,
    borderRadius: '0.25rem',
    display: 'flex',
    justifyContent: 'space-between',
    ...(forBrands(theme, {
      br: getBRStyles,
      brfs: getBRStyles,
      default: () => getDefaultStyles(newDashboard),
    }) as CSSObject),
    '.sort-by-price-dropdown, .size-model-toggle': {
      width: '100%',
      marginRight: '0',
      marginLeft: '0',
      '&-native': {
        width: 'auto',
      },
      '&__menu': {
        top: '100%',
        marginTop: `${borderWidth}px`,
        width: '100%',
      },
      '&__control': {
        paddingRight: '0',
        textAlign: 'center',
        overflow: 'visible',
        width: 'auto',
        fontWeight: 500,
        fontSize: '14px',
        '&:before': {
          display: 'none',
        },
      },
      '&__option, &-native__option': {
        width: '100%',
        textAlign: 'center',
        padding: '0.5rem',
        border: borderStyle,
        borderBottom: 'none',
        '&:first-of-type': {
          borderTop: 'none',
        },
        '&:last-of-type': {
          borderBottom: borderStyle,
        },
      },
      '&-native__select': {
        textAlignLast: 'center',
        top: 0,
        ...(newDashboard
          ? {
              fontWeight: 'normal',
              background: 'none',
              paddingRight: 0,
              '@media (max-width: 1023px) and (min-width: 768px)': {
                fontSize: '0.9rem',
              },
            }
          : {}),
      },
    },
  });
};

const Dashboard = styled.div<DashBoardProps>`
  ${getDashboardStyles};
`;

export default Dashboard;
